<template>
  <PopupModal :open="open" has-close-button @close="close">
    <template #body>
      <div>
        <div>
          <AssistantSmiling class="mx-auto mb-8" />
        </div>
        <div class="text-large mb-8">
          {{ t("comp.challenge.teams.join.dialog.text", { s: name }) }}
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row w-full justify-center gap-4">
        <div class="text-center">
          <ButtonElement
            :label="
              t('custom.challenge.track.progress.negative.button.caption')
            "
            :disabled-visible="true"
            @click="close"
          />
        </div>
        <div class="text-center">
          <ButtonElement
            :label="t('comp.challenge.teams.join.dialog.join.button.caption')"
            @click="join"
          />
        </div>
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import PopupModal from "../layout/PopupModal.vue";
import ButtonElement from "../form/ButtonElement.vue";
import AssistantSmiling from "../icon/AssistantSmiling.vue";
import { useUserStore } from "../../../store/v2/user";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { joinTeam } from "../../../api/v2/competitive-challenge.ts";
const { t } = useI18n();

const router = useRouter();
const user = useUserStore();
const emit = defineEmits(["close", "updateHistory"]);

const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
  id: {
    type: Number,
  },
  name: {
    type: String,
  },
  challengeId: {
    type: String,
  },
});

async function join() {
  const res = await joinTeam(user.externalUserId, props.id);

  if (res) {
    emit("close");
    router.push({
      name: "competitiveChallengeDetail",
      params: { challengeId: props.challengeId },
    });
  }
}

function close() {
  emit("close");
}
</script>
